import styled from 'styled-components';
import { colors } from '@keen.io/colors';
export var CurrentValue = styled.div.withConfig({
  displayName: "Gaugestyles__CurrentValue",
  componentId: "keen-widget-settings__sc-1580qdo-0"
})(["&&&{display:inline-block;background-color:", ";padding:10px;}"], colors.gray[100]);
export var InputContainer = styled.div.withConfig({
  displayName: "Gaugestyles__InputContainer",
  componentId: "keen-widget-settings__sc-1580qdo-1"
})(["&&&{width:100%;max-width:140px;}&&& input[type='number']::-webkit-inner-spin-button,&&& input[type='number']::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}&&& input[type='number']{-moz-appearance:textfield;}"]);
export var FieldsWrapper = styled.div.withConfig({
  displayName: "Gaugestyles__FieldsWrapper",
  componentId: "keen-widget-settings__sc-1580qdo-2"
})(["&&&{margin-top:20px;max-width:250px;width:100%;}"]);